import IconCaretSelect from './component.jsx'
export default IconCaretSelect
